import { OidcProvider, TokenRenewMode } from '@axa-fr/react-oidc';
import React, { ReactElement, ReactNode } from 'react';
import Authenticating from './Authenticating';
import SessionLost from './SessionLost';
//import ServiceWorkerNotSupported from './oidc/ServiceWorkerNotSupported';

export default function ThreatAdvisorOidcProvider({
  children,
  authority,
  oidcClientId,
  additionalScopes,
  disableServiceWorker
}: {
  children: ReactNode;
  authority: string;
  oidcClientId: string;
  additionalScopes?: string;
  disableServiceWorker?: boolean;
}): ReactElement {
  const baseUrl = window.location.origin;
  const oidcConfiguration = oidcClientId
    ? {
        authority: authority,
        client_id: oidcClientId,
        redirect_uri: baseUrl + '/authentication/callback',
        //silent_redirect_uri: baseUrl + '/connect/token',
        silent_login_uri: baseUrl + '/silent-login',
        automaticSilentRenew: true,
        silent_login_timeout: 10000,
        scope:
          'offline_access openid profile email' + (additionalScopes ? ` ${additionalScopes}` : ''),
        //extras: { p: 'youhou' },
        token_renew_mode: TokenRenewMode.access_token_or_id_token_invalid,
        refresh_time_before_tokens_expiration_in_second: 40,
        service_worker_relative_url: disableServiceWorker ? '' : '/OidcServiceWorker.js',
        service_worker_only: !disableServiceWorker,
        code_challenge_method: 'S256'
      }
    : undefined;

  return (
    <OidcProvider
      configurationName="config_show_access_token"
      configuration={oidcConfiguration}
      loadingComponent={Authenticating}
      sessionLostComponent={SessionLost}
      authenticatingErrorComponent={Authenticating}
      authenticatingComponent={Authenticating}
      callbackSuccessComponent={Authenticating}
    >
      {children}
    </OidcProvider>
  );
}
